import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./OTPVerification.css";
import image from "./touche logo.png";
import { isEmailValid } from "utilities/validations";
import settings from "config/settings";

const DeleteAccountForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [error, setError] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${settings.userApi}/MailSend`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ emailAddress: email }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send OTP. Please try again.");
      }

      localStorage.setItem("emailAddress", email);
      history.push("/delete-account");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Check email is valid or not 
    if(!isEmailValid(email)){
     setDisable(true) 
    }

    return () => setDisable(false) // cleanup state of loading
  }, [email]);

  return (
    <div className="container">
      <div style={{ width: "400px" }}>
        <h2>Delete Your Account</h2>
        <div style={{ marginBottom: "50px", marginTop: "50px" }}>
          <img width={375} height={75} src={image} alt="Logo" className="delete-account-logo" />
        </div>
        <form onSubmit={handleSubmit} className="form">
          <p style={{ color: "white", textAlign: "center", marginBottom: "20px"}} className="delete-account-para">
            Enter your email to receive an OTP for account deletion.
          </p>
     
         <input
            type="email"
            id="emailAddress"
            name="emailAddress"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            disabled={loading}
            className="input"
            style={{
              width: "100%",
              height: "50px",
              fontSize: "18px",
              textAlign: "center",
              border: "2px solid #3AABF2",
              borderRadius: "8px",
              backgroundColor: "white",
              color: "black",
              marginBottom: "20px",
            }}
          />
          {error && <p style={{marginBottom:"15px",textAlign : "center",width: "100%",lineHeight: "normal"}} className="error">{error}</p>}
          <button type="submit" disabled={disable} className="delete-account-btn">
            {loading ? "Sending..." : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeleteAccountForm;